import React from "react";
import { Link } from "react-router-dom";
import {
  Download,
  ArrowRight,
  ShieldCheck,
  FileText,
  Info,
  Mail,
  Fish,
} from "lucide-react";

const components = [
  {
    title: "Fitoplancton",
    image:
      "/Images/services/enviromental/monitoring/hydrobiology-service/fitoplancton.webp",
  },
  {
    title: "Zooplancton",
    image:
      "/Images/services/enviromental/monitoring/hydrobiology-service/zooplancton.webp",
  },
  {
    title: "Perifiton",
    image:
      "/Images/services/enviromental/monitoring/hydrobiology-service/perifiton.webp",
  },
  {
    title: "Macroinvertebrados bentónicos",
    image:
      "/Images/services/enviromental/monitoring/hydrobiology-service/macroinvertebrado.webp",
  },
  {
    title: "Macrófitas acuáticas",
    image:
      "/Images/services/enviromental/monitoring/hydrobiology-service/macrofita.webp",
  },
  {
    title: "Peces",
    image:
      "/Images/services/enviromental/monitoring/hydrobiology-service/peses.webp",
  },
];

const HydrobiologyService = () => {
  return (
    <>
      {/* HIDROBIOLOGIA */}
      <section className="py-16 md:py-20 bg-white  overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="flex items-center gap-3">
                <div>
                  <span className="text-[#ee7d32] text-xs sm:text-sm font-bold uppercase tracking-[0.2em]">
                    Servicios de Monitoreo
                  </span>

                  <div className="mt-2 w-16 h-[2px] bg-[#ee7d32]/40 rounded-full" />
                </div>
              </div>

              <h2 className="mt-5 text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
                Hidrobiología
              </h2>

              <div className="mt-6 md:mt-8 space-y-5 md:space-y-7">
                <p className="text-[#374151] text-base md:text-lg leading-7 md:leading-8">
                  Grupo Sierra Alta S.A.S. reconoce la relevancia de la matriz
                  hidrobiológica como un indicador esencial para evaluar la
                  salud y calidad de los ecosistemas acuáticos. A través de la
                  identificación y cuantificación de comunidades biológicas,
                  como macroinvertebrados, fitoplancton, zooplancton, perifiton,
                  macrófitas acuáticas y peces, que actúan como bioindicadores
                  naturales, se obtiene información valiosa sobre las
                  condiciones ambientales y los posibles impactos de las
                  actividades humanas o industriales.
                </p>

                <p className="text-[#374151] text-base md:text-lg leading-7 md:leading-8">
                  Mediante metodologías estandarizadas y personal especializado,
                  ofrecemos análisis rigurosos que permiten detectar
                  alteraciones ecológicas, apoyar procesos de diagnóstico
                  ambiental y orientar estrategias de manejo y conservación,
                  contribuyendo así a la protección sostenible de los recursos
                  hídricos.
                </p>
              </div>

              <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4">
                <a
                  href="/Docs/Resolucion_No._0723_del_16_de_junio_de_2027.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center gap-3 bg-[#ee7d32] hover:bg-[#d96d24] text-white px-7 py-4 rounded-lg font-semibold shadow-lg shadow-[#ee7d32]/25 transition-all duration-300 hover:-translate-y-1"
                >
                  <ShieldCheck className="w-5 h-5" color="#ffffff" />

                  <span className="text-white">Ver acreditación</span>

                  <ArrowRight
                    className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
                    color="#ffffff"
                  />
                </a>

                <a
                  href="/Docs/PORTAFOLIO SIERRA ALTA LAA 2026.pdf"
                  download
                  className="group inline-flex items-center justify-center gap-3 border border-[#ee7d32] bg-[#ee7d32]/10 hover:bg-[#ee7d32] px-7 py-4 rounded-lg font-semibold transition-all duration-300 hover:-translate-y-1"
                >
                  <FileText className="w-5 h-5 stroke-[#ee7d32] group-hover:stroke-white transition-colors duration-300" />

                  <span className="text-[#ee7d32] group-hover:text-white transition-colors duration-300">
                    Descargar brochure
                  </span>

                  <Download className="w-5 h-5 stroke-[#ee7d32] group-hover:stroke-white transition-all duration-300 group-hover:translate-y-[2px]" />
                </a>
              </div>
            </div>

            <div className="relative order-1 lg:order-2">
              <div className="absolute -inset-3 md:-inset-4 bg-[#ee7d32]/10 blur-3xl rounded-[50px]" />

              <div className="absolute -top-4 -right-4 w-32 h-32 border border-[#ee7d32]/30 rounded-full" />

              <div className="relative overflow-hidden shadow-2xl group rounded-tl-[90px] rounded-br-[90px] rounded-tr-[28px] rounded-bl-[28px]">
                <img
                  src="/Images/services/enviromental/monitoring/hydrobiology-service/hidrobiologia.webp"
                  alt="Hidrobiologia"
                  className="w-full h-[340px] sm:h-[450px] md:h-[520px] object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />

                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto">
                  <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-4 sm:px-5 shadow-xl">
                    <div className="flex items-center gap-3">
                      <div className="w-11 h-11 rounded-xl bg-[#ee7d32] flex items-center justify-center shrink-0">
                        <Fish className="w-5 h-5" color="white" />
                      </div>

                      <div>
                        <p className="text-white/80 text-xs sm:text-sm">
                          Servicio especializado
                        </p>

                        <h4 className="text-white font-semibold text-sm sm:text-base">
                          Hidrobiología
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute top-0 right-0 w-28 h-28 bg-[#ee7d32]/20 blur-2xl" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COMPONENTES HIDROBIOLÓGICOS */}
      <section className="relative pt-14 pb-6 md:pt-20 md:pb-8 bg-[#f5f5f5] overflow-hidden">
        <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#ee7d32]/5 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[320px] h-[320px] bg-[#ee7d32]/5 rounded-full blur-3xl pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-[#ee7d32] text-xs md:text-sm font-bold uppercase tracking-[0.2em]">
              <span className="w-10 h-px bg-[#ee7d32]" />
              Hidrobiología
            </span>

            <h2 className="mt-4 text-3xl md:text-5xl font-bold text-[#111827] leading-tight tracking-tight">
              Componentes hidrobiológicos evaluados
            </h2>

            <p className="mt-4 text-[#4b5563] text-sm md:text-lg leading-7 md:leading-8">
              Indicadores hidrobiológicos analizados para evaluar el estado
              ecológico, la calidad ambiental y las condiciones biológicas de
              los cuerpos de agua.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {components.map((item, index) => {
              const Icon = item.icon;

              return (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-[26px] border border-[#e8e8e8] bg-white p-5 md:p-6 shadow-[0_8px_24px_rgba(0,0,0,0.04)] transition-all duration-500 hover:-translate-y-1.5 hover:border-[#ffd7bf] hover:shadow-[0_18px_40px_rgba(238,125,50,0.10)]"
                >
                  <div className="absolute -right-10 -top-10 w-32 h-32 bg-[#ee7d32]/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-all duration-500" />

                  <div className="relative flex items-center gap-4">
                    <div className="w-16 h-16 rounded-2xl overflow-hidden border border-[#ffe1cf] bg-[#fff7f2] flex items-center justify-center flex-shrink-0 transition-all duration-500 group-hover:scale-105">
                      {item.image ? (
                        <img
                          src={item.image}
                          alt={item.title}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <Icon size={28} color="#ee7d32" strokeWidth={2.2} />
                      )}
                    </div>

                    <div className="min-w-0">
                      <h3 className="text-[17px] md:text-lg font-semibold text-[#111827] leading-snug">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ACLARACIÓN */}
      <section className="pt-0 pb-14 md:pb-20 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#f9eee7] border-l-4 border-orange-500 rounded-xl shadow-sm">
            <div className="p-6 md:p-7 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center">
                  <Info size={24} color="#ee7d32" className="h-12 w-12" />
                </div>

                <div>
                  <h4 className="text-sm font-semibold text-gray-900">
                    Aclaración normativa
                  </h4>

                  <p className="text-sm text-gray-600 leading-relaxed mt-2 max-w-3xl">
                    La caracterización hidrobiológica permite la aplicación de
                    índices que facilitan la comprensión del estado de los
                    cuerpos de agua en relación con el componente biológico
                    acuático.
                  </p>
                </div>
              </div>

              <a
                href="/Docs/PORTAFOLIO SIERRA ALTA LAA 2026.pdf"
                download
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5
                    rounded-lg bg-[#ee7d32] text-white text-sm font-medium
                    hover:bg-orange-600 transition"
              >
                Descargar brochure
                <Download size={16} color="white" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA MONITOREO */}
      <section className="relative py-14 md:py-20 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="group relative overflow-hidden rounded-[28px] md:rounded-[30px] border border-[#ececec] bg-white shadow-[0_10px_35px_rgba(0,0,0,0.04)] transition-all duration-300 hover:shadow-[0_18px_50px_rgba(0,0,0,0.08)]">
            <div className="absolute top-0 left-0 h-full w-1.5 bg-gradient-to-b from-[#ee7d32] via-orange-400 to-[#ee7d32]" />

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 px-5 py-7 sm:px-6 md:px-8 md:py-8 lg:px-10 lg:py-10">
              <div className="flex flex-col sm:flex-row items-start gap-5 max-w-3xl">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-[#ee7d32]/20 blur-xl rounded-2xl" />

                  <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center">
                    <Mail
                      size={34}
                      className="md:w-[42px] md:h-[42px] stroke-[#ee7d32] transition-colors duration-300"
                    />
                  </div>
                </div>

                <div className="min-w-0">
                  <span className="inline-flex items-center rounded-full bg-[#ee7d32]/10 border border-[#ee7d32]/20 px-3 py-1 text-[11px] md:text-[12px] font-semibold uppercase tracking-wider text-[#ee7d32]">
                    Asesoría técnica especializada
                  </span>

                  <h3 className="mt-3 text-xl sm:text-2xl md:text-3xl font-bold tracking-tight text-[#111827] leading-tight">
                    ¿Necesitas monitoreo ambiental confiable para tu proyecto?
                  </h3>

                  <p className="mt-3 text-sm md:text-base leading-6 md:leading-7 text-[#6b7280] max-w-2xl">
                    Recibe acompañamiento técnico especializado en monitoreo,
                    control y gestión ambiental con soluciones adaptadas a las
                    necesidades de tu operación.
                  </p>
                </div>
              </div>

              <div className="flex w-full lg:w-auto">
                <Link
                  to="/contact-us?division=ambiental&service=Monitoreo ambiental"
                  className="group/btn inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-lg bg-[#ee7d32] px-6 py-3.5 md:px-7 md:py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#e56f20] hover:shadow-lg hover:shadow-[#ee7d32]/20"
                >
                  Contáctanos
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover/btn:translate-x-1"
                    color="white"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HydrobiologyService;
